'use strict';

exports.__esModule = true;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ParagraphStyle = function ParagraphStyle() {
  var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  (0, _classCallCheck3.default)(this, ParagraphStyle);

  this.indent = attributes.indent || 0;
  this.bullet = attributes.bullet || null;
  this.paddingTop = attributes.paddingTop || attributes.padding || 0;
  this.paragraphSpacing = attributes.paragraphSpacing || 0;
  this.marginLeft = attributes.marginLeft || attributes.margin || 0;
  this.marginRight = attributes.marginRight || attributes.margin || 0;
  this.align = attributes.align || 'left';
  this.alignLastLine = attributes.alignLastLine || (this.align === 'justify' ? 'left' : this.align);
  this.justificationFactor = attributes.justificationFactor || 1;
  this.hyphenationFactor = attributes.hyphenationFactor || 0;
  this.shrinkFactor = attributes.shrinkFactor || 0;
  this.lineSpacing = attributes.lineSpacing || 0;
  this.lineHeight = attributes.lineHeight || 0;
  this.hangingPunctuation = attributes.hangingPunctuation || false;
  this.truncationMode = attributes.truncationMode || (attributes.truncate ? 'right' : null);
  this.maxLines = attributes.maxLines || Infinity;
};

exports.default = ParagraphStyle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-pdf/textkit-core/dist/models/ParagraphStyle.js
// module id = 498
// module chunks = 0